import { render } from "./StandardResourceCard.vue?vue&type=template&id=45c3fe65&scoped=true"
import script from "./StandardResourceCard.vue?vue&type=script&lang=js"
export * from "./StandardResourceCard.vue?vue&type=script&lang=js"

import "./StandardResourceCard.vue?vue&type=style&index=0&id=45c3fe65&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c3fe65"]])

export default __exports__